// Mirrors the backend's downloadExport gate (WS.downloadFile): without one of these
// the Excel file is generated but its download is refused.
export const canExportSurveyAnswers = (user) => {
    const permissions = user?.permissions;
    return (
        permissions?.EXPORT_HIGH_LIMIT === 1 ||
        permissions?.EXPORT_LOW_LIMIT === 1 ||
        permissions?.EXPORT_CAMPAIGNS === 1
    );
};
